import { ThemeSwitcher } from "./theme-switcher";

function AuthPage({
  children,
  title,
}: {
  children: React.ReactNode;
  title: string;
}) {
  return (
    <div className="flex h-screen w-full flex-col items-center justify-center overflow-auto bg-secondary-background bg-[url('/images/bg.png')] bg-cover bg-center">
      <div className="absolute left-0 top-0 z-0 h-full w-full bg-[url('/images/lines.svg')] bg-cover bg-center dark:bg-[url('/images/lines-dark.svg')]" />
      <div className="flex w-full justify-end p-4">
        <ThemeSwitcher />
      </div>

      <div className="z-10 flex w-full flex-1 flex-col items-center justify-center">
        <div className="flex w-full flex-col gap-4 bg-surface-background p-6 sm:w-[28rem]">
          <div className="text-3xl">{title}</div>
          <div className="border-b border-stroke-line" />
          {children}
        </div>
      </div>
    </div>
  );
}

export default AuthPage;
